import axios from "axios";

const state = {
  gastos: [],
  solicitudesGasto: [],
  combustibles: [],
  categoriasGasto: [],
  tiposCombustible: [],
  grifos: [],
  autos: [],
};

const mutations = {
  SET_GASTOS(state, gastos) { state.gastos = gastos; },
  ADD_GASTO(state, gasto) { state.gastos.unshift(gasto); },
  UPDATE_GASTO(state, gasto) {
    const idx = state.gastos.findIndex((g) => g.id === gasto.id);
    if (idx !== -1) state.gastos.splice(idx, 1, gasto);
  },
  DELETE_GASTO(state, id) {
    state.gastos = state.gastos.filter((g) => g.id !== id);
  },

  SET_SOLICITUDES_GASTO(state, items) { state.solicitudesGasto = items; },
  UPSERT_SOLICITUD_GASTO(state, s) {
    const idx = state.solicitudesGasto.findIndex((x) => x.id === s.id);
    if (idx !== -1) state.solicitudesGasto.splice(idx, 1, s);
    else state.solicitudesGasto.unshift(s);
  },
  DELETE_SOLICITUD_GASTO(state, id) {
    state.solicitudesGasto = state.solicitudesGasto.filter((s) => s.id !== id);
  },

  SET_COMBUSTIBLES(state, items) { state.combustibles = items; },
  ADD_COMBUSTIBLE(state, c) { state.combustibles.unshift(c); },
  UPDATE_COMBUSTIBLE(state, c) {
    const idx = state.combustibles.findIndex((x) => x.id === c.id);
    if (idx !== -1) state.combustibles.splice(idx, 1, c);
  },
  DELETE_COMBUSTIBLE(state, id) {
    state.combustibles = state.combustibles.filter((c) => c.id !== id);
  },

  SET_CATEGORIAS_GASTO(state, items) { state.categoriasGasto = items; },
  SET_TIPOS_COMBUSTIBLE(state, items) { state.tiposCombustible = items; },
  SET_GRIFOS(state, items) { state.grifos = items; },
  SET_AUTOS(state, items) { state.autos = items; },
};

const actions = {
  async fetchGastos({ commit }, params = {}) {
    const { data } = await axios.get("/api/gasto", { params });
    commit("SET_GASTOS", data);
    return data;
  },
  async getGastoById(_, id) {
    const { data } = await axios.get(`/api/gasto/${id}`);
    return data;
  },
  async guardarGasto({ commit }, gasto) {
    const { data } = await axios.post("/api/gasto", gasto);
    commit("ADD_GASTO", data);
    return data;
  },
  async updateGasto({ commit }, gasto) {
    const { data } = await axios.put(`/api/gasto/${gasto.id}`, gasto);
    commit("UPDATE_GASTO", data);
    return data;
  },
  async deleteGasto({ commit }, id) {
    await axios.delete(`/api/gasto/${id}`);
    commit("DELETE_GASTO", id);
  },

  async fetchSolicitudesGasto({ commit }, params = {}) {
    const { data } = await axios.get("/api/solicitud-gasto", { params });
    commit("SET_SOLICITUDES_GASTO", data);
    return data;
  },
  async guardarSolicitudGasto({ commit }, payload) {
    const { data } = await axios.post("/api/solicitud-gasto", payload);
    commit("UPSERT_SOLICITUD_GASTO", data);
    return data;
  },
  async updateSolicitudGasto({ commit }, payload) {
    const { data } = await axios.put(`/api/solicitud-gasto/${payload.id}`, payload);
    commit("UPSERT_SOLICITUD_GASTO", data);
    return data;
  },
  async deleteSolicitudGasto({ commit }, id) {
    await axios.delete(`/api/solicitud-gasto/${id}`);
    commit("DELETE_SOLICITUD_GASTO", id);
  },
  async aprobarSolicitudGasto({ commit }, { id, observacion }) {
    const { data } = await axios.post(`/api/solicitud-gasto/${id}/aprobar`, { observacion });
    commit("UPSERT_SOLICITUD_GASTO", data);
    return data;
  },
  async rechazarSolicitudGasto({ commit }, { id, observacion }) {
    const { data } = await axios.post(`/api/solicitud-gasto/${id}/rechazar`, { observacion });
    commit("UPSERT_SOLICITUD_GASTO", data);
    return data;
  },

  async fetchCombustibles({ commit }, params = {}) {
    const { data } = await axios.get("/api/combustible", { params });
    commit("SET_COMBUSTIBLES", data);
    return data;
  },
  async getCombustibleById(_, id) {
    const { data } = await axios.get(`/api/combustible/${id}`);
    return data;
  },
  async guardarCombustible({ commit }, payload) {
    const { data } = await axios.post("/api/combustible", payload);
    commit("ADD_COMBUSTIBLE", data);
    return data;
  },
  async updateCombustible({ commit }, payload) {
    const { data } = await axios.put(`/api/combustible/${payload.id}`, payload);
    commit("UPDATE_COMBUSTIBLE", data);
    return data;
  },
  async deleteCombustible({ commit }, id) {
    await axios.delete(`/api/combustible/${id}`);
    commit("DELETE_COMBUSTIBLE", id);
  },

  async fetchCategoriasGasto({ commit }) {
    const { data } = await axios.get("/api/categoria-gasto");
    commit("SET_CATEGORIAS_GASTO", data);
    return data;
  },
  async fetchTiposCombustible({ commit }) {
    const { data } = await axios.get("/api/tipo-combustible");
    commit("SET_TIPOS_COMBUSTIBLE", data);
    return data;
  },
  async fetchGrifos({ commit }) {
    const { data } = await axios.get("/api/grifo");
    commit("SET_GRIFOS", data);
    return data;
  },
  async fetchAutosForGasto({ commit }) {
    const { data } = await axios.get("/api/auto").catch(() => ({ data: [] }));
    commit("SET_AUTOS", data);
    return data;
  },
};

const getters = {
  gastos: (state) => state.gastos,
  solicitudesGasto: (state) => state.solicitudesGasto,
  combustibles: (state) => state.combustibles,
  categoriasGasto: (state) => state.categoriasGasto,
  tiposCombustible: (state) => state.tiposCombustible,
  grifos: (state) => state.grifos,
  autos: (state) => state.autos,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
